export default {"src":"/_next/static/media/Bitcoin.ed26e748.svg","height":73,"width":74};